<template>
  <div class="background">
    <div class="container">
      <br />
      <br />
      <br />
      <div class="loginComponent shadow p-4">
        <h1 class="title">Welcome Back!</h1>
        <h5 class="title text-center">Log in</h5>
        <br />
        <div class="alert red text-white errMsg none">{{ err }}</div>
        <br />
        <input
          type="email"
          placeholder="Enter Your Email"
          class="form-control email"
          name="email"
          v-model="email"
        />
        <br />
        <input
          type="password"
          placeholder="Enter Your Password"
          class="form-control password"
          name="password"
          v-model="password"
        /><br />
        <button
          disabled
          @click="login()"
          class="form-control login text-white primary btn"
        >
          Log in
        </button>
        <br />
        <br />
        <p class="suggestion hna">have no account?</p>
        <router-link id="rl" to="/register"
          ><p class="link text-primary">Sign Up</p></router-link
        ><br />
        <p class="suggestion fp">forgot your password?</p>
        <router-link id="rl" to="/forgotpassword"
          ><p class="link text-primary">Change Password</p></router-link
        >
      </div>
      <!-- Background Image Owner Account -->
      <!-- <p class="text-white owner-credit text-right">
        Photo by <a href="https://unsplash.com/@chuttersnap">chuttersnap</a> on
        <a href="https://unsplash.com/">Unsplash</a>
      </p>
    --></div>
    <div class="footerApp">
      <footerApp></footerApp>
    </div>
  </div>
</template>

<script>
// import axios from 'axios';
// IMPORT LINKS FILE
import footerApp from "../components/footer.vue";

const link = require("../.././api.links.config.js");

export default {
  name: "login",
  components: {
    footerApp
  },

  data() {
    return {
      token: window.localStorage.getItem("access-token") || false, // TOKEN

      email: null,

      password: null,

      err: null
    };
  },
  created() {
    // SET SCROLL LEVEL TO 0 WHICH MEANS TO THE TOP
    window.scrollTo(0, 0);
    // auth stuff goes here...
    if (this.token) {
      this.$router.push("/");
    }
  },
  watch: {
    email: function(email) {
      if (email.length < 10 && !email.includes("@") && !email.includes(".")) {
        document.querySelector(".email").style.border = ".5px solid red";
      } else {
        document.querySelector(".email").style.border = "";
      }
    },
    password: function(password) {
      if (password.length < 7) {
        document.querySelector(".password").style.border = ".5px solid red";
      } else {
        document.querySelector(".password").style.border = "";

        // DISPLAY REGISTER BUTTON AFTER VALIDATE DATA
        document.querySelector(".login").removeAttribute("disabled");
      }
    }
  },
  methods: {
    login: function() {
      // CHANGE BTN CONTENT
      document.querySelector(
        ".login"
      ).innerHTML = `<span class="spinner-grow spinner-grow-sm text-dark" role="status" aria-hidden="true"></span>
        Please Wait...`;

      //  INIT BODY DATA
      const body = { email: this.email, password: this.password };

      //REQUEST THE SERVER
      this.$http({
        url: link.baselink + "/auth/login",
        method: "post",
        data: body
      })

        .then(res => {
          // console.log(res.data)
          // CHECK USER IF LOGGED IN
          if (res.data.loggedIn === true && res.data.Message === "Welcome") {
            // STORE TOKEN IN THE LOCAL STORAGE
            window.localStorage.setItem("access-token", res.data.token);

            // RELOAD TO UPDATE HEADER
            window.location.reload();

            //REDIRECT THE USER TO THE DASHBOARD
            //this.$router.push("/dashboard");
          } else if (
            res.data.loggedIn === false &&
            res.data.Message != "Welcome"
          ) {
            // alert(res.data.Message)
            // PUT ERR MESSAGE TO THE GLOBAL VARIABLE
            this.err = res.data.Message;

            // CHANGE BTN CONTENT
            document.querySelector(".login").innerHTML = "Log In";

            // DISPLAY ERR MESSAGE
            document.querySelector(".errMsg").classList.remove("none");
            document.querySelector(".errMsg").classList.add("block");

            // INVISIBLE ERR MESSAGE AFTER 5S
            window.setTimeout(() => {
              document.querySelector(".errMsg").classList.remove("block");
              document.querySelector(".errMsg").classList.add("none");
            }, 5000);

            // MENTION TO USER THAT HE'IS ABSOLUTLY FORGOT HIS PASSWORD
            document.querySelector(".fp").style.color = "red";
            document.querySelector(".fp").style.fontWeight = "bolder";

            /*window.setTimeout(()=>{
              document.querySelector('.fp').style.color = 'var(--bg-color)';
              document.querySelector('.fp').style.fontWeight = '100';
            },10000)*/
          }
        })
        .catch(err => {
          // Something goes here...
          // console.log(err);
          alert(err.message);
        });
    }
  }
};
</script>

<style lang="css" scoped>
.title {
  color: var(--bg-color);
}
.background {
  /*background-image: url('.././assets/atul-vinayak-hZioHCEWSAE-unsplash.jpg'); /*Photo by Atul Vinayak on Unsplash  Mt Fuji */
  /*background-image: url(".././assets/chuttersnap-C4Lrq1F3vDQ-unsplash.jpg"); /*Photo by chuttersnap on Unsplash koalalampur city*/
  /* background-image: url('.././assets/owen-lystrup-boLgiM0qwkg-unsplash.jpg');*/ /*Photo by Owen Lystrup on Unsplash city in us */
  background-attachment: ;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 100vh;
}
.owner-credit {
  margin-top: 12%;
}
.loginComponent {
  border-radius: 3px;
  width: 40%;
  margin: 0 auto;
  background-color: white;
  position: relative;
  top: 30%;
  /*opacity: 0.9;*/
  transition: all 0.2s ease-out;
}
/*.loginComponent:hover {
  opacity: .9;
}*/
.suggestion {
  color: var(--bg-color);
  font-weight: 100;
  font-size: 12px;
  display: inline;
  padding: 3px;
}
.link {
  font-weight: 100;
  font-size: 12px;
  display: inline;
  padding: 3px;
}
input {
  font-size: 13px;
}
.red {
  background-color: var(--dan-ger);
}
.primary {
  background-color: var(--primary-color);
}
.none {
  display: none;
}
.block {
  display: block;
}
.inline {
  display: inline;
}
.footerApp {
  margin-top: 100px;
}
@media only screen and (max-width: 600px) {
  .loginComponent {
    width: 100%;
  }
  .title {
    font-size: 30px !important;
  }
}
</style>
